export default {
  setRations: (state, value) => (state.rations = value),
  resetRations: (state) => (state.rations = null)
}
